import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { Reveal } from "@/components/site/Reveal";
import { IMG, waLink, onWhatsApp } from "@/lib/site";

const MARQUEE = [
  "Guincho 24 Horas", "Reboque", "Transporte de Veículos", "Carros e Motos",
  "Jundiaí e Região", "Atendimento Ágil", "Socorro Veicular",
];

export const Precisou = () => {
  return (
    <>
      <section className="relative overflow-hidden">
        <div className="container-x py-24 md:py-32 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <span className="text-brand font-display text-lg font-bold uppercase tracking-[0.2em]">
              Precisou de guincho?
            </span>
            <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[0.92]">
              Estamos prontos<br />para atender.
            </h2>
            <p className="mt-6 text-lg text-zinc-400 max-w-xl">
              A DG Guinchos oferece atendimento para remoção e transporte de veículos em
              Jundiaí e região. Trabalhamos com responsabilidade e cuidado para transportar
              seu veículo com segurança.
            </p>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="precisou-cta"
              onClick={() => onWhatsApp("precisou")}
              className="mt-8 group inline-flex items-center gap-3 bg-brand hover:bg-brand-hover text-white font-display font-bold uppercase tracking-wider text-lg px-8 py-4 rounded-sm transition-all active:scale-95"
            >
              <WhatsAppIcon className="h-6 w-6" /> Solicitar Guincho Agora
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </Reveal>

          <Reveal delay={0.15} className="relative">
            <div className="relative aspect-[4/5] sm:aspect-[4/3] lg:aspect-[4/5] overflow-hidden rounded-sm border border-white/10">
              <img
                src={IMG.emergency}
                alt="Motorista aguardando socorro ao lado de veículo com problema, atendimento DG Guinchos"
                loading="lazy"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-5 -left-3 sm:left-6 bg-brand text-white px-6 py-4 rounded-sm shadow-2xl">
              <div className="font-display text-4xl font-black leading-none">24H</div>
              <div className="text-xs font-semibold uppercase tracking-widest">Todos os dias</div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Editorial marquee */}
      <div className="relative border-y border-white/10 bg-brand overflow-hidden py-4 select-none">
        <motion.div className="flex whitespace-nowrap" aria-hidden="true">
          <div className="flex animate-marquee">
            {[...MARQUEE, ...MARQUEE].map((m, i) => (
              <span key={i} className="mx-6 font-display text-2xl md:text-3xl font-black uppercase text-white/95 flex items-center gap-6">
                {m} <span className="text-white/50">✕</span>
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </>
  );
};
